import ReactDOM from "react-dom";

import App from "./App"
import "./components/estilos/estilos.scss"
import 'sweetalert2/src/sweetalert2.scss'

ReactDOM.render(<App/>,document.getElementById("root"));

